import React from 'react';

// Hidden SEO content component - contains keywords and FAQs for search engines
// This content is hidden visually but accessible to search engines
const SEOContent = () => {
  return (
    <div style={{ 
      position: 'absolute', 
      left: '-9999px', 
      top: '-9999px',
      opacity: 0,
      pointerEvents: 'none'
    }}>
      <h1>Yuppy NYC Dog Social App - Manhattan Brooklyn Queens Bronx Staten Island</h1>
      <h2>NYC Dog Community App Features</h2>
      <p>Yuppy is the premier dog social network for New York City, serving Manhattan, Brooklyn, Queens, the Bronx, and Staten Island. Our daily photo challenges bring together NYC dog owners from Central Park to Prospect Park, Washington Square to DUMBO.</p>
      
      <h3>Frequently Asked Questions</h3>
      <div>
        <h4>What is Yuppy dog app?</h4>
        <p>Yuppy is NYC's first daily dog social app where you post, share, and compete with other NYC dog owners. Join themed photo challenges and connect with the city's dog community.</p>
        
        <h4>Is Yuppy available in Brooklyn?</h4>
        <p>Yes! Yuppy serves all five NYC boroughs including Brooklyn, Manhattan, Queens, the Bronx, and Staten Island. Connect with Brooklyn dogs from Park Slope to Williamsburg.</p>
        
        <h4>How do I join NYC dog meetups?</h4>
        <p>Use Yuppy to discover and join dog meetups across NYC. Find events in Central Park, Prospect Park, and neighborhood dog runs throughout the city.</p>
        
        <h4>What are daily dog photo challenges?</h4>
        <p>Every 24 hours, Yuppy releases new themed photo challenges for NYC dogs. Submit your pup's best shot and compete for the top spot on the leaderboard.</p>
        
        <h4>Can I connect with Manhattan dog owners?</h4>
        <p>Absolutely! Yuppy connects dog owners across Manhattan, from the Upper East Side to SoHo, creating a vibrant community of city dogs and their people.</p>
      </div>
      
      <h3>NYC Dog Parks and Locations</h3>
      <p>Central Park dog runs, Prospect Park off-leash areas, Washington Square Park, Tompkins Square Park, Battery Park, Riverside Park, Brooklyn Bridge Park, and neighborhood dog parks across all five boroughs.</p>
      
      <h3>Keywords</h3>
      <p>NYC dog app, Manhattan dogs, Brooklyn dog community, Queens dog owners, Bronx dog meetups, Staten Island dogs, Central Park dogs, Prospect Park dogs, NYC dog social network, daily dog challenges, dog photo contests, city dogs, urban dog community, NYC dog parks, Manhattan dog meetups, Brooklyn dog social app, Queens dog community app</p>
    </div>
  );
};

export default SEOContent;
